import { Box, styled } from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";


function TradeWalletAction() {
  const { source } = useParams();
  // const navigate = useNavigate();

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const basketId = +searchParams.get("basketId") || tradeInsertForm?.basketId;
  const brokerId = +searchParams.get("brokerId") || tradeInsertForm?.brokerId;

  const handleBorrow = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      borrow: source,
      basketId
    });
  };


  const handleRepay = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      repay: source,
      basketId
    });
  };

  return (
    <Box>
      <ButtonStyleTrade
        variant="contained"
        fullWidth
        component={Link}
        to={`/broker/${brokerId}`}
      >
        View Information
      </ButtonStyleTrade>

      <ButtonStyleTrade
        variant="contained"
        fullWidth
        onClick={handleBorrow}
      >
        Borrow
      </ButtonStyleTrade>

      <ButtonStyleTrade variant="contained" fullWidth onClick={handleRepay}>
        Repay
      </ButtonStyleTrade>
    </Box>
  );
}

export const ButtonStyleTrade = styled(LoadingButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.buttonAction,
  color: theme.palette.common.white,
  borderRadius: "8px",
  maxWidth: "auto",
  minHeight: "35px !important",
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  textAlign: 'center',

  "&:hover": {
    color: `${theme.palette.text.main} !important`,
  },
}));

export default TradeWalletAction;
